import {
    Container,
    Paper,
    Skeleton,
    Grid,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Stack
} from '@mui/material';

export default function SkeletonFormCotacao() {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                {/* Header */}
                <Box textAlign="center" sx={{ mb: 4 }}>
                    <Skeleton variant="text" width="60%" height={48} sx={{ margin: '0 auto', mb: 2 }} />
                    <Skeleton variant="text" width="40%" height={32} sx={{ margin: '0 auto' }} />
                </Box>

                <Skeleton variant="rectangular" height={1} sx={{ mb: 4 }} />

                {/* Detalhes da Solicitação */}
                <Box sx={{ mb: 4 }}>
                    <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
                    <Grid container spacing={3}>
                        <Grid size={{xs: 12, md: 6}}>
                            <Skeleton variant="text" width="30%" height={24} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width="60%" height={28} />
                        </Grid>
                        <Grid size={{xs: 12, md: 6}}>
                            <Skeleton variant="text" width="30%" height={24} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width="60%" height={28} />
                        </Grid>
                    </Grid>
                </Box>

                <Skeleton variant="rectangular" height={1} sx={{ mb: 4 }} />

                {/* Configurações da Cotação */}
                <Box sx={{ mb: 4 }}>
                    <Skeleton variant="text" width="35%" height={32} sx={{ mb: 2 }} />
                    <Grid container spacing={3}>
                        <Grid size={{xs: 12, md: 4}}>
                            <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                        </Grid>
                    </Grid>
                </Box>

                {/* Produtos e Valores */}
                <Box sx={{ mb: 4 }}>
                    <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
                    
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                                <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                                <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                                <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                                <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[1, 2, 3].map((row) => (
                                <TableRow key={row}>
                                    <TableCell>
                                        <Stack spacing={1}>
                                            <Skeleton variant="text" width="50%" height={20} />
                                            <Skeleton variant="text" width="80%" height={24} />
                                            <Skeleton variant="text" width="60%" height={18} />
                                        </Stack>
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="text" width="70%" height={24} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="rectangular" width={80} height={40} sx={{ borderRadius: 1 }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>

                {/* Botão */}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Skeleton variant="rectangular" width={200} height={48} sx={{ borderRadius: 1 }} />
                </Box>
            </Paper>
        </Container>
    );
}